const downloadCsv = (
  rows: Array<Array<string | number>>,
  filename: string,
  headers?: Array<string>
) => {
  let content = "data:text/csv;charset=utf-8,";
  content += [...(!!headers ? [headers] : []), ...rows]
    .map((row) =>
      row
        .map(String)
        .map((v) => v.replaceAll('"', '""'))
        .map((v) => `"${v}"`)
        .join(",")
    )
    .join("\r\n");
  const encodedUri = encodeURI(content);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", `${filename}.csv`);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export default downloadCsv;
